'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('logout', {
      url: '/logout',
      template: '<logout></logout>'
    });
}



// WEBPACK FOOTER //
// ./client/app/logout/logout.routes.js